define.alias("ember-math-helpers/helpers/ceil", "settings/helpers/ceil");